module.exports = __webpack_public_path__ + "static/media/alexa__sees__in__colour-IG-3.e77dfc10.PNG";